module.exports = __webpack_public_path__ + "static/media/image.b9f5c341.svg";